import { render, staticRenderFns } from "./assignDialog.vue?vue&type=template&id=4177d491&scoped=true"
import script from "./assignDialog.vue?vue&type=script&lang=js"
export * from "./assignDialog.vue?vue&type=script&lang=js"
import style0 from "./assignDialog.vue?vue&type=style&index=0&id=4177d491&prod&lang=scss&scoped=true"
import style1 from "./assignDialog.vue?vue&type=style&index=1&id=4177d491&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4177d491",
  null
  
)

export default component.exports